import React from 'react'
// import { generate_random } from '../../functions/functions'

function WorkFlow(props) {
  return (
    <>
        <div  className="strategy">
        <h2>{props.index}</h2>
        <h3>{props.title}</h3>
      </div>
      <div  className="our_work_flow_horizontal_bar"></div>

        </>
  )
}
WorkFlow.defaultProps={
    title:"nothing",
    index:"1"
}
export default WorkFlow